import { PublicConfig } from "@/viaduct-api";
import { createContext, useContext } from "react";

interface ConfigContextType {
  config?: PublicConfig;
  fetching: boolean;
  loaded: boolean;
}

export const ConfigContext = createContext<ConfigContextType>({
  config: undefined,
  fetching: false,
  loaded: false,
});

export const useConfig = () => useContext(ConfigContext);
